export default {
  printer: {
    qzConnected: false,
  },
  deliverymenOnline: 0,
}
